(function () {
  'use strict';

  class ConfirmDeleteModalCtrl {
    constructor($uibModalInstance, compartilhamento) {
      this.modalInstance = $uibModalInstance;
      this.compartilhamento = compartilhamento;
    }

    confirmar() {
      this.modalInstance.close();
    }

    cancel() {
      this.modalInstance.dismiss();
    }
  }

  angular
    .module('compartilhamentos')
    .controller('ConfirmDeleteModalCtrl', ConfirmDeleteModalCtrl);
}());

